import { IkasCategory } from "../category";
import { IkasProductVariant } from "./variant";
import { IkasProductAttributeValue } from "./attribute-value";
import { IkasProductVariantType } from "./variant-type";
import { IkasBrand } from "../brand";
import { IkasHTMLMetaData } from "../html-meta-data";
import { IkasProductTag } from "./tag";
import { IkasVariantValue } from "../variant-type/variant-value";
import { IkasVariantType } from "../variant-type";
import { IkasProductBaseUnit } from "./base-unit";

export type IkasProduct = {
  id: string;
  name: string;
  type: IkasProductType;
  description: string;
  shortDescription: string;
  metaData: IkasHTMLMetaData | null;
  brand: IkasBrand | null;
  categories: IkasCategory[];
  tags: IkasProductTag[] | null;
  variants: IkasProductVariant[];
  attributes: IkasProductAttributeValue[];
  variantTypes: IkasProductVariantType[];
  productOptionSetId: string | null;
  baseUnit: IkasProductBaseUnit | null;
  averageRating: number | null;
  reviewCount: number | null;
};

export enum IkasProductType {
  PHYSICAL = "PHYSICAL",
  DIGITAL = "DIGITAL",
  MEMBERSHIP = "MEMBERSHIP",
}

export type IkasDisplayedVariantValue = {
  variant: IkasProductVariant; // TODO remove?
  variantValue: IkasVariantValue;
  hasStock: boolean;
  isSelected: boolean;
};

export type IkasDisplayedVariantType = {
  variantType: IkasVariantType;
  displayedVariantValues: IkasDisplayedVariantValue[];
};
